<template>
  <SysDialog
    v-model="DIALOG_ATIVO"
    :titulo="`Relatório ${relatorio.title}`"
    txt-botao="Gerar relatório"
    @click:primary="gerarRelatorio"
  >
    <div class="d-flex align-center mb-n4">
      <div class="w-50-porcento pr-2">
        <SysDatePicker
          v-model="filtros.data_inicial"
          outlined
          titulo_label="Data Inicial"
          :error-messages="DATA_INI_ERRORS"
        />
      </div>

      <div class="w-50-porcento pl-2">
        <SysDatePicker
          v-model="filtros.data_final"
          titulo_label="Data Final"
          outlined
          :error-messages="DATA_FIN_ERRORS"
        />
      </div>
    </div>
  </SysDialog>
</template>

<script>
import { required } from "vuelidate/lib/validators";
import Mixin from "@/components/Relatorios/Mixin";
import SysGrupoAutocomplete from "@/components/utils/crud/SysGrupoAutocomplete";
import SysFilialGrupoAutocomplete from "@/components/utils/crud/SysFilialGrupoAutocomplete";
import $axios from "@/api/api";
import SysDatePicker from '@/components/utils/SysDatePicker.vue';

export default {
  name: "Exemplo",
  mixins: [Mixin],
  components: {
    SysFilialGrupoAutocomplete,
    SysGrupoAutocomplete,
    SysDatePicker
  },
  data: () => ({
    filtros: {
      data_inicial: '',
      data_final: ''
    }
  }),
  computed: {
    DATA_INI_ERRORS() {
      const errors = [];
      if (!this.$v.filtros.data_inicial.$dirty) return errors;
      !this.$v.filtros.data_inicial.required && errors.push("Campo Obrigatório.");
      return errors;
    },
    DATA_FIN_ERRORS() {
      const errors = [];
      if (!this.$v.filtros.data_final.$dirty) return errors;
      !this.$v.filtros.data_final.required && errors.push("Campo Obrigatório.");
      return errors;
    },
  },
  methods: {
    gerarRelatorio() {
      this.$v.$touch();

      if (this.$v.$invalid) return;

      const url = `${this.relatorio.url}${this.Helpers.formatarParametrosObjParaUrl(this.filtros)}`;
      window.open(`${$axios.defaults.baseURL}/${url}`, "_blank");
      this.DIALOG_ATIVO = false;
    }
  },
  validations: {
    filtros: {
      data_inicial: { required },
      data_final: { required },
    }
  }
}
</script>

<style scoped>

</style>
